module.exports = __webpack_public_path__ + "img/print.dc529264.svg";